import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { CoachesDataService, CoachesColumnsService } from '../../../services';
import { Coach, CoachesResult } from '../../../interfaces';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-coach-form',
  templateUrl: './coach-form.component.html',
  styleUrls: ['./coach-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class CoachFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public coach: Coach = {};
  public coachForm: FormGroup = new FormGroup({});
  public coaches: Coach[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;

  private filerDialog: DynamicDialogRef = new DynamicDialogRef();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private coachesDataService: CoachesDataService,
    public coachesColumnsService: CoachesColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'CoachFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Coach - Edit');
        this.getCoach(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.coach !== 'undefined') {
      this.coach = this.dynamicDialogConfig.data.coach;
    }
    if (typeof this.coach.id === 'undefined' || this.coach.id === null) {
      this.coach.id = null;
      this.coach.isPublished = false;
    }
    this.getCoaches();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'CoachFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'CoachFormComponent');
  }

  getCoach(id: number): void {
    this.isLoading = true;
    this.coachesDataService.getCoach(id).subscribe((response: Coach|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.coach = response;
        this.prepareFrom();
      }
    });
  }

  getCoaches(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.coaches !== 'undefined' && this.dynamicDialogConfig.data.coaches.length > 0) {
      this.coaches = this.dynamicDialogConfig.data.coaches;
      return;
    }
    this.coachesDataService.getCoaches(this.parameters).subscribe((response: CoachesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.coaches = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.coachForm = new FormGroup({
      id: new FormControl(this.coach.id, []),
      name: new FormControl(this.coach.name, [Validators.required, ]),
      nameAr: new FormControl(this.coach.nameAr, []),
      nameFr: new FormControl(this.coach.nameFr, []),
      user: new FormControl((typeof this.coach.user === 'number') ? this.coach.user : this.coach.user?.id, [Validators.required, ]),
      description: new FormControl(this.coach.description, []),
      photo: new FormControl(this.coach.photo, []),
      isPublished: new FormControl(this.coach.isPublished, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/coaches']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.coachForm.controls).forEach((field: any) => {
        const control = this.coachForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.coachForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.coach = this.coachForm.value;
    this.disableSubmit = true;
    console.log('coach', this.coach);
    if (typeof this.coach.id !== 'undefined' && this.coach.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.coachesDataService.updateCoach(this.coach).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('COACHUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('COACHNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.coachesDataService.addCoach(this.coach).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('COACHCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('COACHNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  openFilerDialog(field: string): void {
    let url = '';
    const control = this.coachForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'coaches',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.coachForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

}

@Component({
  selector: 'app-coach-form',
  templateUrl: './coach-form.component.html',
  styleUrls: ['./coach-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogCoachFormComponent extends CoachFormComponent {
}

